export const servicesConstants = {
    URL_SERVER: "http://localhost:5000/",
    CANCEL_REQUEST: 'CANCEL',
    SUBDOMAIN: localStorage.getItem("subdomainTributFacil") ? localStorage.getItem("subdomainTributFacil") : null
};